import { TLocalStorageItem } from "./type";

export const getKey = (applicationId: string, type: TLocalStorageItem) =>
  `${applicationId}:${type}`;
